var moduleMap = {
	"./diContainer": () => {
		return __webpack_require__.e(/* diContainer */ "diContainer").then(() => (() => ((__webpack_require__("./src/service-setup/diContainer.ts")))));
	},
	"./account-dashboard": () => {
		return __webpack_require__.e(/* account-dashboard */ "account-dashboard").then(() => (() => ((__webpack_require__("./src/exported/account-dashboard/index.ts")))));
	},
	"./account-orders": () => {
		return __webpack_require__.e(/* account-orders */ "account-orders").then(() => (() => ((__webpack_require__("./src/exported/account-orders/index.ts")))));
	},
	"./account-sidebar": () => {
		return __webpack_require__.e(/* account-sidebar */ "account-sidebar").then(() => (() => ((__webpack_require__("./src/exported/account-sidebar/index.ts")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var oldScope = __webpack_require__.S["default"];
	var name = "default"
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});